import React, { useState,useContext } from 'react';
import { ArrowLeft, Bell, Heart, Bookmark, Phone, Star, Minus, Plus } from 'lucide-react';

import { useNavigate } from 'react-router-dom';
import AppContext from '../../context/AppContext';

const Achat = () => {
  const [quantity, setQuantity] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const navigate = useNavigate();

  const { isSplashVisible, isLoading,id,userInfos ,bottom,unProduit} = useContext(AppContext);
  const incrementQuantity = () => {
    setQuantity(prev => prev + 1);
  };

  const decrementQuantity = () => {
    if (quantity > 0) {
      setQuantity(prev => prev - 1);
    }
  };

  return (
    <div className="min-h-screen bg-purple-50">
      {/* Header */}
      

      {/* Main Content */}
      <main className="px-4 py-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-3">Détails</h2>
        <p className="text-gray-600 mb-6">
          Profitez d'une expérience fluide et sécurisée, sans redirection inutile. Simple, rapide, sécurisé !
        </p>

        {/* Product Card */}
        <div className="bg-white rounded-3xl p-4 shadow-sm">
          {/* Product Image */}
          <div className="w-full h-64 bg-gray-100 rounded-2xl mb-4 overflow-hidden">
            <img
              src={unProduit.imageUrl}
              alt="SmartFit Pro"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Product Info */}
          <div className="space-y-4">
            <div className="flex justify-between items-start">
              <h3 className="text-2xl font-bold text-gray-900">{unProduit.title}</h3>
              <span className="text-blue-600 text-2xl font-bold">{unProduit.price} F CFA   </span>
            </div>

            <p className="text-gray-600">
            {unProduit.description}
            </p>

            {/* Rating */}
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  className={`w-5 h-5 ${
                  'text-blue-600 fill-blue-600'
                  }`}
                />
              ))}
            </div>

            {/* Quantity Selector */}
          {
/*
  <div className="flex items-center gap-4">
              <div className="flex items-center bg-blue-50 rounded-xl">
                <button
                  onClick={decrementQuantity}
                  className="p-2 text-blue-600 hover:bg-blue-100 rounded-l-xl transition-colors"
                >
                  <Minus className="w-5 h-5" />
                </button>
                <span className="w-12 text-center font-medium">{quantity}</span>
                <button
                  onClick={incrementQuantity}
                  className="p-2 text-blue-600 hover:bg-blue-100 rounded-r-xl transition-colors"
                >
                  <Plus className="w-5 h-5" />
                </button>
              </div>

              <button
                onClick={() => setIsFavorite(!isFavorite)}
                className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
              >
                <Heart
                  className={`w-6 h-6 ${
                    isFavorite ? 'text-red-500 fill-red-500' : 'text-gray-400'
                  }`}
                />
              </button>

              <button
                onClick={() => setIsBookmarked(!isBookmarked)}
                className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
              >
                <Bookmark
                  className={`w-6 h-6 ${
                    isBookmarked ? 'text-blue-600 fill-blue-600' : 'text-gray-400'
                  }`}
                />
              </button>
            </div>
*/

          }

            {/* Action Buttons */}
            <div className="flex gap-3 pt-2">
              <button 
              onClick={()=>{
              //  navigate("/IndexPaiementAbonnement")

              navigate("/PaymentSelector")
              }}
              
              className="flex-1 bg-blue-600 text-white py-3 rounded-xl font-medium hover:bg-blue-700 transition-colors">
                Acheter ce produit
              </button>
              <button className="w-12 h-12 bg-white text-red-500 rounded-xl flex items-center justify-center  transition-colors">
              <Heart
                  className={`w-6 h-6 ${
                    isFavorite ? 'text-red-500 fill-red-500' : 'text-red-500 fill-red-500'
                  }`}
                />
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Achat;